import { subDays, isBefore, differenceInDays } from 'date-fns';
import { toLower } from 'lodash';
import moment from 'moment';

import { formatDate, getCurrentTimezone, getDateInstance } from '@orion/fe-utils';

export const importDateLocale = async (lang: string) => {
    const languageKey = toLower(lang);

    try {
        await import(`../../../node_modules/moment/dist/locale/${languageKey}.js`);
        moment.locale(languageKey);
    } catch (e) {
        const strippedLang = languageKey.substring(0, 2);

        try {
            await import(`../../../node_modules/moment/dist/locale/${strippedLang}.js`);
            moment.locale(languageKey);
        } catch (err) {
            try {
                await import(`../i18n/locales/${strippedLang}-moment.ts`);
                moment.locale(languageKey);
            } catch (r) {
                // TODO: Handle error properly — left empty to preserve legacy behavior
            }
        }
    }
};

export function formatDateForLog(datetime: Date | string): string {
    const englishDatetime = getDateInstance(datetime, null, 'en'); // To prevent logging Arabic dates

    return formatDate('MMM D, YYYY HH:mm:ss z', englishDatetime, null, getCurrentTimezone());
}

export const isOver30days = (targetDate: Date) => {
    const thirtyDaysAgo = subDays(new Date(), 30);
    const isOlderThan30Days = isBefore(targetDate, thirtyDaysAgo);
    return isOlderThan30Days;
};

export const daysSinceToday = (dateString: string | null): number | null => {
    if (!dateString) {
        return null;
    }
    const parseDate = new Date(dateString);
    if (isNaN(parseDate.getTime())) {
        return null;
    }
    const daysSinceToday = differenceInDays(new Date(), parseDate);
    return daysSinceToday;
};
